import React, { useEffect } from "react";
import AboutDescription from "../../components/AboutDescription/AboutDescription";
import PageTop from "../../components/PageTop/PageTop";
import Footer from "../../components/Footer/Footer";
import MainNav from "../../shared/MainNav/MainNav";
import AboutMe from "../../components/AboutMe/AboutMe";

export default function About() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="About Us" />
      <PageTop pageTitle="About Us" />
      <AboutDescription />
      <AboutMe />

      <Footer />
    </>
  );
}
